import React, { Component } from 'react';
import Link from 'gatsby-link';
import { observer, inject } from 'mobx-react';

import colors from '../../../vars/colors';

import {Row, Column} from '../../global/grid/grid';
import Image from '../../global/media/Image';
import StatCircle from '../StatCircle/StatCircle';
import { CaseStudyThumbWrapper } from './styled-components';

import ArrowCtaRed from '../../../static/svgs/arrow-cta-red.svg';
import ArrowCtaBlue from '../../../static/svgs/arrow-cta-blue.svg';

@inject("store")
@observer class CaseStudyThumb extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ctaHovered: false,
            positioningValue: 0
        };

        // bind events to context
        this.ctaEntered = this.ctaEntered.bind(this);
        this.ctaExited = this.ctaExited.bind(this);        
        this.handleScroll = this.handleScroll.bind(this);
        this.setVanishingPoint = this.setVanishingPoint.bind(this);
        this.gaCityClicked = this.gaCityClicked.bind(this);
    }
    componentDidMount() {
        document.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.setVanishingPoint);
        setTimeout(() => {
          this.setVanishingPoint();
        }, 100);
    }
    componentWillUnmount() {
        document.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.setVanishingPoint);
    }
    handleScroll(e) {
        this.latestKnownScrollY = window.scrollY ? window.scrollY : window.pageYOffset;
        this.requestTick();
    }
    requestTick() {
        if(!this.ticking) {
            requestAnimationFrame(this.update.bind(this));
        }
        this.ticking = true;
    }
    setVanishingPoint() {
        const scrollTop = document.documentElement ? document.documentElement.scrollTop : document.body.scrollTop;
        const thumbTop = this.thumbHolder.getBoundingClientRect().top;
        const thumbHeight = this.thumbHolder.getBoundingClientRect().height;
        this.vanishingPoint = scrollTop + thumbTop + (thumbHeight / 2);
    }
    update() {
        const { data } = this.props;
        this.ticking = false;
        const posValCalc = 1 - (window.innerHeight - (this.vanishingPoint - this.latestKnownScrollY)) / window.innerHeight;
        let positioningValue = 0;
        if(posValCalc < 1 && posValCalc > 0) {
          positioningValue = Math.round((1 - posValCalc) * 100) / 100;
        } else if(posValCalc < 0) {
          positioningValue = 1;
        } else {
          positioningValue = 0;
        }
        if(positioningValue !== this.state.positioningValue) {
            this.setState(
                {
                    positioningValue: positioningValue,
                }
            );
        }
    }
    ctaEntered() {
        if(this.state.ctaHovered === false) {
            this.setState({
                ctaHovered: true
            });
        }
    }
    ctaExited() {
        if(this.state.ctaHovered === true) {
            this.setState({
                ctaHovered: false
            });
        }
    }
    gaCityClicked() {
        const { data } = this.props;
        window.dataLayer.push({
            'event': 'homepage-explore:click',
            'city': data.city + ',' + data.state
        });
    }
    render() {
        const {data, imageDictionary, store} = this.props;
        if(data.direction === 'left') {
            return (
                <div ref={(div) => this.thumbHolder = div}>
                    <CaseStudyThumbWrapper color={data.color} direction={data.direction} thumbStyle={data.style}>
                        { store.isMobile &&
                            <span className="mobileWrapper">
                                <div className="thumbTextHolder">
                                    <div className="rotatedText">
                                        <div className="city">{data.city}</div>
                                        <div className="state">{data.state}</div>
                                    </div>
                                </div>
                                <div
                                className="ctaHolder"
                                onMouseEnter={this.ctaEntered}
                                onMouseLeave={this.ctaExited}
                                >
                                    <Link to={data.ctaLink} onClick={this.gaCityClicked}>
                                        { data.color === 'red' ? <ArrowCtaRed /> : <ArrowCtaBlue /> }
                                        <div className="ctaText left">
                                            {data.cta}
                                        </div>
                                    </Link>
                                </div>
                                <div className="initialsHolder">
                                    <span style={{transform: `translate3d(0, ${-30 + (30 * ( this.state.positioningValue > 0.33 ? 1 : this.state.positioningValue * 3))}px, 0) rotate(${-20 + (20 * ( this.state.positioningValue > 0.5 ? 1 : this.state.positioningValue * 2))}deg)`}}>{data.initials[0]}</span>
                                    <span style={{transform: `translate3d(0, ${120 + (-120 * ( this.state.positioningValue > 0.33 ? 1 : this.state.positioningValue * 3))}px, 0) rotate(${15 + (-15 * ( this.state.positioningValue > 0.5 ? 1 : this.state.positioningValue * 2))}deg)`}}>{data.initials[1]}</span>
                                </div>
                            </span>
                        }
                        <Column cw={5} offset={1}>
                            <Link to={data.ctaLink} onClick={this.gaCityClicked}>
                                <div className="thumbImageWrapper">
                                    <Image aspectHeight={6} aspectWidth={5} sizes={imageDictionary[data.image].sizes} />
                                    <div className={`colorBlock ${data.style === 'main' ? 'main' : 'alternate'} ${data.direction === 'left' ? 'left' : 'right'}`}>
                                        <div className={`stripes ${this.state.ctaHovered ? 'ctaHovered' : ''}`}></div>
                                    </div>
                                    <div 
                                        className="frameHolder"
                                        style={{
                                            transform: `translate3d(${-25 + (50 * ( this.state.positioningValue > 0.5 ? 1 : this.state.positioningValue * 2))}px, ${30 + (-60 * ( this.state.positioningValue > 0.5 ? 1 : this.state.positioningValue * 2))}px, 0)`
                                        }}
                                    >
                                    </div>
                                    <div className={`dataCounter ${this.state.ctaHovered ? 'ctaHovered' : ''}`}>
                                        <StatCircle data={data.datapoint} imageDictionary={imageDictionary} />
                                    </div>
                                </div>
                            </Link>
                        </Column>
                        { !store.isMobile &&
                        <Column cw={4} offset={1} style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'space-evenly',
                            position: 'relative',
                        }}>
                            <div className="thumbTextHolder">
                                <div className="rotatedText">
                                    <div className="city">{data.city}</div>
                                    <div className="state">{data.state}</div>
                                </div>
                            </div>
                            <div
                            className="ctaHolder"
                            onMouseEnter={this.ctaEntered}
                            onMouseLeave={this.ctaExited}
                            >
                                <Link to={data.ctaLink} onClick={this.gaCityClicked}>
                                    { data.color === 'red' ? <ArrowCtaRed /> : <ArrowCtaBlue /> }
                                    <div className="ctaText left">
                                        {data.cta}
                                    </div>
                                </Link>
                            </div>
                            <div className="initialsHolder">
                                <span style={{transform: `translate3d(0, ${-30 + (30 * ( this.state.positioningValue > 0.33 ? 1 : this.state.positioningValue * 3))}px, 0) rotate(${-20 + (20 * ( this.state.positioningValue > 0.5 ? 1 : this.state.positioningValue * 2))}deg)`}}>{data.initials[0]}</span>
                                <span style={{transform: `translate3d(0, ${120 + (-120 * ( this.state.positioningValue > 0.33 ? 1 : this.state.positioningValue * 3))}px, 0) rotate(${15 + (-15 * ( this.state.positioningValue > 0.5 ? 1 : this.state.positioningValue * 2))}deg)`}}>{data.initials[1]}</span>
                            </div>
                        </Column>
                        }
                    </CaseStudyThumbWrapper>
                </div>
            )
        } else {
            return (
                <div ref={(div) => this.thumbHolder = div}>
                    <CaseStudyThumbWrapper color={data.color} direction={data.direction} thumbStyle={data.style}> 
                        { store.isMobile &&
                            <span className="mobileWrapper">
                                <div className="thumbTextHolder">
                                    <div className="rotatedText">
                                        <div className="city">{data.city}</div>
                                        <div className="state">{data.state}</div>
                                    </div>
                                </div>
                                <div
                                className="ctaHolder"
                                onMouseEnter={this.ctaEntered}
                                onMouseLeave={this.ctaExited}
                                >
                                    <Link to={data.ctaLink} onClick={this.gaCityClicked}>
                                        { data.color === 'red' ? <ArrowCtaRed style={{transform: 'scaleX(-1)'}}/> : <ArrowCtaBlue style={{transform: 'scaleX(-1)'}}/> }
                                        <div className="ctaText right">
                                            {data.cta}
                                        </div>
                                    </Link>
                                </div>
                                <div className="initialsHolder">
                                    <span style={{transform: `translate3d(0, ${-30 + (30 * ( this.state.positioningValue > 0.33 ? 1 : this.state.positioningValue * 3))}px, 0) rotate(${-20 + (20 * ( this.state.positioningValue > 0.5 ? 1 : this.state.positioningValue * 2))}deg)`}}>{data.initials[0]}</span>
                                    <span style={{transform: `translate3d(0, ${120 + (-120 * ( this.state.positioningValue > 0.33 ? 1 : this.state.positioningValue * 3))}px, 0) rotate(${15 + (-15 * ( this.state.positioningValue > 0.5 ? 1 : this.state.positioningValue * 2))}deg)`}}>{data.initials[1]}</span>
                                </div>
                            </span>
                        }
                        { !store.isMobile &&                   
                        <Column cw={4} offset={1} style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'space-evenly',
                            position: 'relative',
                        }}>
                            <div className="thumbTextHolder">
                                <div className="rotatedText">
                                    <div className="city">{data.city}</div>
                                    <div className="state">{data.state}</div>
                                </div>
                            </div>
                            <div
                            className="ctaHolder"
                            onMouseEnter={this.ctaEntered}
                            onMouseLeave={this.ctaExited}
                            >
                                <Link to={data.ctaLink} onClick={this.gaCityClicked}>
                                { data.color === 'red' ? <ArrowCtaRed style={{transform: 'scaleX(-1)'}}/> : <ArrowCtaBlue style={{transform: 'scaleX(-1)'}}/> }
                                    <div className="ctaText right">
                                        {data.cta}
                                    </div>
                                </Link>
                            </div>
                            <div className="initialsHolder">
                                <span style={{transform: `translate3d(0, ${-30 + (30 * ( this.state.positioningValue > 0.33 ? 1 : this.state.positioningValue * 3))}px, 0) rotate(${-20 + (20 * ( this.state.positioningValue > 0.5 ? 1 : this.state.positioningValue * 2))}deg)`}}>{data.initials[0]}</span>
                                <span style={{transform: `translate3d(0, ${120 + (-120 * ( this.state.positioningValue > 0.33 ? 1 : this.state.positioningValue * 3))}px, 0) rotate(${15 + (-15 * ( this.state.positioningValue > 0.5 ? 1 : this.state.positioningValue * 2))}deg)`}}>{data.initials[1]}</span>
                            </div>
                        </Column>
                        }
                        <Column cw={5} offset={1}>
                            <Link to={data.ctaLink} onClick={this.gaCityClicked}>
                                <div className="thumbImageWrapper">
                                    <Image aspectHeight={6} aspectWidth={5} sizes={imageDictionary[data.image].sizes} />
                                    <div className={`colorBlock ${data.style === 'main' ? 'main' : 'alternate'} ${data.direction === 'left' ? 'left' : 'right'}`}>
                                        <div className={`stripes ${this.state.ctaHovered ? 'ctaHovered' : ''}`}></div>
                                    </div>
                                    <div 
                                        className="frameHolder"
                                        style={{
                                            transform: `translate3d(${25 + (-50 * ( this.state.positioningValue > 0.5 ? 1 : this.state.positioningValue * 2))}px, ${30 + (-60 * ( this.state.positioningValue > 0.5 ? 1 : this.state.positioningValue * 2))}px, 0)`
                                        }}
                                    >
                                    </div>
                                    <div className={`dataCounter ${this.state.ctaHovered ? 'ctaHovered' : ''}`}>
                                        <StatCircle data={data.datapoint} imageDictionary={imageDictionary} />
                                    </div>
                                </div>
                            </Link>
                        </Column>
                    </CaseStudyThumbWrapper>
                </div>
            )
        }
    }
};

export default CaseStudyThumb;



// WEBPACK FOOTER //
// ./src/components/modules/CaseStudyThumb/CaseStudyThumb.js